import { Typography } from '@design-system/components/typography/typography';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { Button } from '@design-system/components/button/button';
import { sprinkles } from '@design-system/sprinkles.css';

export type HintType = { title?: string; description?: string };

type HintProps = {
  hint: HintType;
  onUpdate: (hint: HintType) => void;
};
export const Hint = (p: HintProps) => {
  if (!p.hint) return null;

  return (
    <div>
      <Tooltip
        title={<TooltipContent {...p} />}
        variant="dark"
        arrow={false}
        tooltipProps={{ maxWidth: '400px', minHeight: '100px' }}
      >
        <Typography
          as="p"
          className={sprinkles({ color: 'N-80' })}
          variant="body"
          size="small"
        >
          Do you want to apply the description and title from library?{' '}
          <Typography
            className={sprinkles({ color: 'P-60' })}
            variant="body"
            size="small"
          >
            Yes, use it
          </Typography>
        </Typography>
      </Tooltip>
    </div>
  );
};

const TooltipContent = ({ hint, onUpdate }: HintProps) => (
  <div className="flex flex-col gap-4 p-4">
    {!hint?.title ? null : (
      <div className="flex flex-col gap-2">
        <Typography>{hint.title}</Typography>
      </div>
    )}
    {!hint?.description ? null : (
      <div className="flex flex-col gap-2">
        <Typography>{hint.description}</Typography>
      </div>
    )}
    <div className="flex justify-end">
      <Button variant="text" onClick={() => onUpdate(hint)}>
        Use library content
      </Button>
    </div>
  </div>
);
